import { DateOffsetPeriodQueryParams } from "../models/ProjectDocQuery";

export function toCreatedQueryParams(range: [Date, Date] | null): DateOffsetPeriodQueryParams | undefined {
  if (!range) return undefined;
  const [from, to] = range;
  const moreOrEquals = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 0, 0, 0, 0);
  const lessOrEquals = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59, 999);
  return { MoreOrEquals: moreOrEquals, LessOrEquals: lessOrEquals };
}

export function fromCreatedQueryParams(q: any): (Date | null)[] | null {
  return q?.MoreOrEquals && q?.LessOrEquals ? [new Date(q.MoreOrEquals), new Date(q.LessOrEquals)] : null;
}
